import React, { useState } from 'react';
import '../styles/CommentSection.css';

const CommentSection = ({ comments, onCommentSubmit }) => {
  const [commentText, setCommentText] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Simple validation
    if (!commentText.trim() || !name.trim()) {
      setError('Name and comment are required');
      return;
    }
    
    // Email validation (simple check)
    if (email && !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    
    try {
      const commentData = {
        name,
        email,
        text: commentText,
        timestamp: new Date().toISOString(),
      };
      
      const success = await onCommentSubmit(commentData);
      
      if (success) {
        setCommentText('');
        setSuccess(true);
        
        // Clear success message after delay
        setTimeout(() => {
          setSuccess(false);
        }, 3000);
      } else {
        setError('Failed to post comment. Please try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Format the date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleString(undefined, options);
  };

  return (
    <div className="comment-section">
      <h2>Comments ({comments.length})</h2>
      
      <div className="comment-form-container">
        <h3>Leave a Comment</h3>
        
        <form className="comment-form" onSubmit={handleSubmit}>
          {error && <div className="comment-error">{error}</div>}
          {success && <div className="comment-success">Comment posted successfully!</div>}
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name <span className="required">*</span></label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email (optional)</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="comment">Comment <span className="required">*</span></label>
            <textarea
              id="comment"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              rows="4"
              required
              placeholder="Share your thoughts on this work"
            ></textarea>
          </div>
          
          <button 
            type="submit" 
            className="submit-comment-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Posting...' : 'Post Comment'}
          </button>
        </form>
      </div>
      
      <div className="comments-list">
        {comments.length === 0 ? (
          <div className="no-comments">
            <p>No comments yet. Be the first to share your thoughts!</p>
          </div>
        ) : (
          comments.map((comment, index) => (
            <div key={comment.id || index} className="comment">
              <div className="comment-header">
                <div className="comment-avatar">
                  {comment.name[0].toUpperCase()}
                </div>
                <div className="comment-meta">
                  <span className="comment-author">{comment.name}</span>
                  <span className="comment-date">{formatDate(comment.timestamp)}</span>
                </div>
              </div>
              <div className="comment-body">
                <p>{comment.text}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CommentSection;